<template>
  <div class="example-full mt-3">
    <h3 id="example-title" class="example-title text-center">{{$ml.get('upload_new')}}</h3>
    <div v-if="!hidePlatformDiv" class="row justify-content-center">
      <h3 class="col-12 example-title text-center">{{$ml.get('upload_media_type')}}</h3>
      <div class="col-3 mb-5">
        <div @click="platform = 'captive'" class="card-stats justify-content-center text-center">
          <n-radio v-model="platform" :inline="true" label="captive" />
          <span :style="platform === 'captive' ? 'color: #2a5788!important; border-bottom: 1px solid; transition: ease 0.5s;' : ''"><b> WiFi </b></span>
        </div>
      </div>
      <div v-if="showBillboard" class="col-3 mb-5">
        <div @click="platform = 'billboard'" class="card-stats justify-content-center text-center">
          <n-radio v-model="platform" :inline="true" label="billboard" />
          <span :style="platform === 'billboard' ? 'color: #2a5788!important; border-bottom: 1px solid; transition: ease 0.5s;' : ''"><b> Billboard </b></span>
        </div>
      </div>
      <div class="col-3 mb-5">
        <div @click="platform = 'logo'" class="card-stats justify-content-center text-center">
          <n-radio v-model="platform" :inline="true" label="logo" />
          <span :style="platform === 'logo' ? 'color: #2a5788!important; border-bottom: 1px solid; transition: ease 0.5s;' : ''"><b> Logo </b></span>
        </div>
      </div>
      <div class="col-3 mb-5">
        <div @click="platform = 'bg'" class="card-stats justify-content-center text-center">
          <n-radio v-model="platform" :inline="true" label="bg" />
          <span :style="platform === 'bg' ? 'color: #2a5788!important; border-bottom: 1px solid; transition: ease 0.5s;' : ''"><b> {{$ml.get('background')}} </b></span>
        </div>
      </div>
    </div>
    <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
      <h3>{{$ml.get('drop_files')}}</h3>
    </div>

    <div v-if="platform !== ''" class="upload">
      <div class="table-responsive">
        <table class="table table-hover">
          <thead v-show="files.length">
          <tr>
            <th>{{$ml.get('media')}}</th>
            <th>{{$ml.get('name')}}</th>
            <th>{{$ml.get('status')}}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-show="!files.filter(file => file.progress !== '100.00').length">
            <td colspan="7">
              <div class="text-center p-5">
                <h4>{{$ml.get('drop_files')}}<br><br>{{$ml.get('or')}}</h4>
                <file-upload
                  class="btn btn-lg btn-primary"
                  :post-action="postAction"
                  :extensions="extensions"
                  :accept="accept"
                  :multiple="multiple"
                  :directory="directory"
                  :size="size || 0"
                  :thread="thread"
                  :headers="headers"
                  :data="data"
                  :drop="drop"
                  :drop-directory="dropDirectory"
                  :add-index="addIndex"
                  name="media"
                  v-model="files"
                  @input-filter="inputFilter"
                  @input-file="inputFile"
                  ref="upload">
                  {{$ml.get('select_file')}}
                </file-upload>
                <br>
                <h4>{{$ml.get('or')}}<br><br>{{$ml.get('upload_via_external_link')}}</h4>
                <form @submit.prevent="mediaUrlUpload" class="row">
                  <fg-input
                    v-model="mediaUrl"
                    :placeholder="'Media Url'"
                    v-validate="{url: {require_protocol: true }}"
                    class="mt-4 col-md-6 el-col-md-offset-6"
                  >
                  </fg-input>
                </form>
                <button @click="mediaUrlUpload" class="btn btn-primary btn-lg mt-3"> {{$ml.get('upload')}} </button>
              </div>
            </td>
          </tr>
          <tr v-for="(file, index) in files" :key="file.id" v-show="file.progress !== '100.00'">
            <td>
              <img v-if="file.thumb" :src="file.thumb" width="100" height="auto" />
              <span v-else-if="file.type === 'video/mp4'">Video</span>
              <span v-else>{{$ml.get('no_file')}}</span>
            </td>
            <td>
              <div class="filename">
                {{file.name}}
              </div>
              <div class="progress" v-if="file.active || file.progress !== '0.00'">
                <div :class="{'progress-bar': true, 'progress-bar-striped': true, 'bg-danger': file.error, 'progress-bar-animated': file.active}" role="progressbar" :style="{width: file.progress + '%'}">{{file.progress}}%</div>
              </div>
            </td>

            <td v-if="file.error">{{file.error}}</td>
            <td v-else-if="file.success">{{$ml.get('success')}}</td>
            <td v-else-if="file.active">{{$ml.get('active')}}</td>
            <td v-else></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!---

    Crop image modal

    --->
    <modal :show.sync="editFile.show && init && platform !== 'billboard' && !editFile.type.includes('gif')" footer-classes="justify-content-center" type="notice" :showClose="false">
      <form @submit.prevent="onEditorFile">
        <div class="modal-body">
          <div class="form-group" v-if="editFile.show && editFile.blob && editFile.type && editFile.type.substr(0, 6) === 'image/'">
            <div v-if="showCropOptions" class="row justify-content-center">
              <h5 class="col-12 example-title text-center">{{$ml.get('crop')}}</h5>
              <div class="col-3 mb-5">
                <div class="card-stats justify-content-center text-center">
                  <n-radio v-model="aspectRatio" :label="'0.75'"> <b> 3:4 </b> </n-radio>
                </div>
              </div>
              <div class="col-3 mb-5">
                <div class="card-stats justify-content-center text-center">
                  <n-radio v-model="aspectRatio" :label="'1'"> <b> 1:1 </b> </n-radio>
                </div>
              </div>
              <div class="col-3 mb-5">
                <div class="card-stats justify-content-center text-center">
                  <n-radio v-model="aspectRatio" :label="'1.33'"> <b> 4:3 </b> </n-radio>
                </div>
              </div>
              <div class="col-3 mb-5">
                <div class="card-stats justify-content-center text-center">
                  <n-radio v-model="aspectRatio" :label="'1.77'"><b>16:9</b></n-radio>
                </div>
              </div>
              <div class="col-3 mb-5">
                <div class="card-stats justify-content-center text-center">
                  <n-radio v-model="aspectRatio" :label="'2'"> <b> 2:1 </b> </n-radio>
                </div>
              </div>
            </div>
            <div class="edit-image">
              <img :src="editFile.blob" ref="editImage"/>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger" @click.prevent="$refs.upload.remove(files[0]); init = false; editFile.show = false; init = false;">{{$ml.get('delete')}}</button>
          <button type="submit" class="btn btn-success">{{$ml.get('crop') + ' ' + $ml.get('and') + ' ' + $ml.get('save')}}</button>
        </div>
      </form>
    </modal>
  </div>
</template>

<script>
  import Radio from './Inputs/Radio'
  import Cropper from 'cropperjs'
  import VueCropper from 'vue-cropperjs'
  import ImageCompressor from 'image-compressor.js'
  import FileUpload from 'vue-upload-component'
  import {mapGetters, mapActions} from 'vuex'
  import Posts from '../services/Posts'
  import Modal from './Modal.vue'
  import to from 'await-to-js';
  import {EventBus} from "../store/event-bus";
  export default {
    name: 'upload',
    props: {
      platformProp: {
        type: String,
        required: false,
        default: ''
      },
      hidePlatformDiv: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    components: {
      [Radio.name]: Radio,
      FileUpload,
      Modal
    },
    data() {
      return {
        mediaUrl: '',
        platform: this.platformProp,
        aspectRatio: '1',
        init: false,
        upload: false,
        files: [],
        accept: 'image/png,image/gif,image/jpeg,video/mp4',
        extensions: 'GIF,JPG,JPEG,PNG,mp4,gif,jpg,jpeg,png,mp4',
        // extensions: ['gif', 'jpg', 'jpeg','png', 'webp'],
        // extensions: /\.(gif|jpe?g|png|webp)$/i,
        minSize: 1024,
        size: 1024 * 1024 * 30,
        multiple: false,
        directory: false,
        drop: true,
        dropDirectory: true,
        addIndex: false,
        thread: 1,
        name: 'file',
        putAction: '/upload/put',
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        },
        data: {},
        autoCompress: 500 * 500,
        uploadAuto: false,
        addData: {
          show: false,
          name: '',
          type: '',
          content: '',
        },
        editFile: {
          show: false,
          name: '',
        }
      }
    },
    mounted() {
      EventBus.$on('companyUpdated', this.$forceUpdate);
    },
    computed: {
      ...mapGetters(['token', 'showBillboard']),
      postAction() {
        let url = process.env.API_ROOT + '/v1/media/upload/?platform=' + this.platform;
        if (localStorage.getItem('role') !== 'client') {
          url = url + '&companyId=' + localStorage.getItem('CompanyId');
        }
        return url;
      },
      maxWidth(){
        return (this.platform === 'logo') ? 200 : 500;
      },
      maxAspectRatio(){
        switch (this.platform) {
          case 'logo': {
            return 1;
          }
          case 'bg': {
            return 3;
          }
          default: {
            return 2;
          }
        }
      },
      minAspectRatio(){
        switch (this.platform) {
          case 'bg': {
            return 3;
          }
          default: {
            return 1;
          }
        }
      },
      showCropOptions() {
        switch (this.platform) {
          case 'logo': return false;
          case 'bg': return false;
          default: return true;
        }
      }
    },
    watch: {
      platform(nv) {
        this.multiple = false;
        switch (nv) {
          case 'logo': {
            return this.aspectRatio = '1';
          }
          case 'bg': {
            return this.aspectRatio = '2';
          }
          case 'billboard': {
            this.multiple = true;
            return this.aspectRatio = '1.33';
          }
          default: {
            return this.aspectRatio = '1.33';
          }
        }
      },
      aspectRatio(nv) {
        if (this.editFile.cropper)
          this.editFile.cropper.setAspectRatio(parseFloat(nv));
      },
      'editFile.show'(newValue, oldValue) {
        let self = this;
        this.editFile.name =
          (this.platform !== 'logo') ?
            ((this.platform !== 'bg') ? this.editFile.name : 'bg' + this.editFile.name.substr(this.editFile.name.indexOf('.')))
            : 'logo' + this.editFile.name.substr(this.editFile.name.indexOf('.'));
          if (!newValue && oldValue) {
            this.$refs.upload.update(this.editFile.id, {error: this.editFile.error || ''})
          }
        if (newValue) {
          this.$nextTick(function () {
            if (!this.$refs.editImage) return;
            let minAspectRatio = self.minAspectRatio;
            let maxAspectRatio = self.maxAspectRatio;
            let cropper = new Cropper(this.$refs.editImage, {
              aspectRatio: parseFloat(this.aspectRatio),
              minCropBoxWidth: 100,
              autoCrop: true,
              viewMode: 1,
              ready: function () {
                let cropper = this.cropper;
                let containerData = cropper.getContainerData();
                let cropBoxData = cropper.getCropBoxData();
                let aspectRatio = cropBoxData.width / cropBoxData.height;
                let newCropBoxWidth;
                if (aspectRatio < minAspectRatio || aspectRatio > maxAspectRatio) {
                  newCropBoxWidth = cropBoxData.height * ((minAspectRatio + maxAspectRatio) / 2);
                  cropper.setCropBoxData({
                    left: (containerData.width - newCropBoxWidth) / 2,
                    width: newCropBoxWidth
                  });
                }
                cropper.autoCrop = true
              },
            });
            this.editFile = {
              ...this.editFile,
              cropper
            };
            this.$forceUpdate()
          })
        }
      },
      'addData.show'(show) {
        if (show) {
          this.addData.name = ''
          this.addData.type = ''
          this.addData.content = ''
        }
      },
    },
    methods: {
      ...mapActions(['fetchGalleryMedias', 'fetchAccount', 'fetchCompanies']),
      inputFilter(newFile, oldFile, prevent) {
        if (newFile && !oldFile) {
          // Before adding a file
          // Filter system files or hide files
          if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
            return prevent()
          }
          // Filter php html js file
          if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
            return prevent()
          }

          // Automatic compression
          if (newFile.file && newFile.type.substr(0, 6) === 'image/' && !newFile.type.includes('gif')) {
            newFile.error = 'compressing'
            var thisInstance = this;

            new ImageCompressor(newFile.file, {
              convertSize: Infinity,
              maxWidth: this.maxWidth,
              success(file) {
                thisInstance.$refs.upload.update(newFile, {error: '', file, size: file.size, type: file.type});
              },
              failure(err) {
                thisInstance.$refs.upload.update(newFile, {error: err.message || 'compress'});
              }
            })
          }
        }
        if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
          // Create a blob field
          newFile.blob = ''
          let URL = window.URL || window.webkitURL
          if (URL && URL.createObjectURL) {
            newFile.blob = URL.createObjectURL(newFile.file)
          }
          // Thumbnails
          newFile.thumb = ''
          if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
            newFile.thumb = newFile.blob
          }
        }
      },
      // add, update, remove File Event
      async inputFile(newFile, oldFile) {
        if (newFile && oldFile) {
          // update
          if (newFile.active && !oldFile.active) {
            // beforeSend
            // min size
            if (newFile.size >= 0 && this.minSize > 0 && newFile.size < this.minSize) {
              this.$refs.upload.update(newFile, {error: 'size'})
            }
          }
          if (newFile.progress !== oldFile.progress) {
            // progress
            return;
          }
          if (newFile.error && !oldFile.error) {
            // error
          }
          if (newFile.success && !oldFile.success) {
            this.successSnack(this.$ml.get('saved'));
            this.init = false
            setTimeout(async () => {
              if (this.account.role === 'admin') await this.fetchCompanies()
              await this.fetchAccount();
              await this.fetchGalleryMedias();
              this.setLoading(false)
              this.$forceUpdate();
            }, 1000);
          }
        }

        if (!newFile && oldFile) {
          // remove
          // oldFile.response.url -> uploaded url from server
          // oldFile.response.id -> media id from server
          if (oldFile.success && oldFile.response.id) {
            let [err] = await Posts.deleteMedia(oldFile.response.id)
            if (err) return this.errorSnack(err);
          }
        }
        // Automatically activate upload
        if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
          if (this.uploadAuto && !this.$refs.upload.active) {
            this.$refs.upload.active = true
          }
        }

        if ((!newFile || !newFile.start) && (!this.init || this.platform !== 'billboard')) {
          this.init = true;
          this.editFile = newFile;
          this.$refs.upload.update(newFile, {error: '', start: true})
          this.editFile.show = true;

          if ((newFile.el && newFile.el.files[0].type === 'video/mp4') || this.platform === 'billboard' || newFile.type.includes('gif')) {
            this.editFile.show = false;
            this.$refs.upload.active = true
            newFile.start = true;
          }

        }
      },
      onEditFileShow(file) {
        this.editFile = {...file, show: true}
        this.$refs.upload.update(file, {error: 'edit'})
      },
      onEditorFile() {
        if (!this.$refs.upload.features.html5) {
          alert('Your browser does not support');
          return
        }
        let data = { name: this.editFile.name };

        this.editFile.show = false;
        if (this.editFile.cropper) {
          if (this.editFile.cropper.getCroppedCanvas() !== null) {
            let binStr = atob(this.editFile.cropper.getCroppedCanvas({maxWidth: this.maxWidth}).toDataURL(this.editFile.type).split(',')[1])
            let arr = new Uint8Array(binStr.length)
            for (let i = 0; i < binStr.length; i++) {
              arr[i] = binStr.charCodeAt(i)
            }
            data.file = new File([arr], data.name, {type: this.editFile.type})
            data.size = data.file.size
          }
        }
        this.setLoading(true)
        this.$refs.upload.update(this.editFile.id, data)
        this.editFile.error = ''
        this.editFile.show = false
        this.upload = false;
        this.$refs.upload.active = true
      },

      async mediaUrlUpload() {
        // Check if instagram post link and add 'media/?size=m' to the path
        try {
          let mediaUrl = this.mediaUrl;
          const url = new URL(mediaUrl);

          /** @deprecated */
          if (url.hostname.includes('instagram.com') && false ) {
            let pathname = url.pathname;
            if (!pathname) throw new Error('wrong_url');

            if (url.pathname.slice(-1) === '/') {
              pathname = pathname.slice(0, -1);
            }
            mediaUrl = url.protocol + '//' + url.hostname + pathname + '/media/?size=m';
          }

          let [err] = await to(Posts.mediaUrlUpload(mediaUrl, this.platform));
          if (err) return this.errorSnack(err);
          this.successSnack(this.$ml.get('saved'));
          this.init = false
          setTimeout(async () => {
            if (this.account.role === 'admin') await this.fetchCompanies()
            await this.fetchAccount();
            await this.fetchGalleryMedias()
            this.setLoading(false)
            this.$forceUpdate();
          }, 1000);
        } catch (e) {
          return this.errorSnack({ message: this.$ml.get('wrong_url') });
        }
      }
    }
  }
</script>

<style>
  .example-full .btn-group .dropdown-menu {
    display: block;
    visibility: hidden;
    transition: all .2s
  }
  .example-full .btn-group:hover > .dropdown-menu {
    visibility: visible;
  }
  .example-full label.dropdown-item {
    margin-bottom: 0;
  }
  .example-full .btn-group .dropdown-toggle {
    margin-right: .6rem
  }
  .example-full .filename {
    margin-bottom: .3rem
  }
  .example-full .btn-is-option {
    margin-top: 0.25rem;
  }
  .example-full .example-foorer {
    padding: .5rem 0;
    border-top: 1px solid #e9ecef;
    border-bottom: 1px solid #e9ecef;
  }
  .example-full .edit-image img {
    max-width: 100%;
  }
  .example-full .edit-image-tool {
    margin-top: .6rem;
  }
  .example-full .edit-image-tool .btn-group{
    margin-right: .6rem;
  }
  .example-full .footer-status {
    padding-top: .4rem;
  }
  .example-full .drop-active {
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    position: fixed;
    z-index: 9999;
    opacity: .6;
    text-align: center;
    background: #000;
  }
  .example-full .drop-active h3 {
    margin: -.5em 0 0;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    font-size: 40px;
    color: #fff;
    padding: 0;
  }
</style>
